import { toastError, toastSuccess } from '@components/Toast/Toast';
import { useBankProfile } from '@contexts/BankProfileContext';
import { useAuth } from '@hooks/useAuth';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface SendMessageParams {
	topic: string;
	content: { text: string };
	attachments?: File[];
	signature: string;
}

export const useCreateMessage = () => {
	const { session } = useAuth();
	const { selectedProfile } = useBankProfile();
	const { t } = useTranslation();
	const navigate = useNavigate();

	const messageCreate = async ({
		topic,
		content,
		attachments,
		signature,
	}: SendMessageParams) => {
		const formData = new FormData();

		formData.append('topic', topic);

		Object.entries(content).forEach(([key, value]) => {
			formData.append(`content[${key}]`, value ?? '');
		});

		if (attachments) {
			attachments.forEach((file, index) => {
				formData.append(`attachments[${index}]`, file);
			});
		}

		const { data } = await axios.post(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/threads`,
			formData,
			{
				headers: {
					Authorization: session?.tokenized,
					'X-Signature': signature,
				},
			},
		);

		return data;
	};

	return useMutation({
		mutationFn: messageCreate,
		onSuccess: () => {
			toastSuccess(t('tfa.alerts.messageSigned'));
			navigate('/messages');
		},
		onError: async () => {
			toastError(t('tfa.alerts.failed'));
		},
	});
};
